<template>
  <div>
    <div class="topright">
      <router-link class="nav-item-button" to="/login">
        <a> <i class="tim-icons icon-single-02"></i> Acessar plataforma </a>
      </router-link>
    </div>
    <!-- <base-nav
      type="white"
      :transparent="true"
      menu-classes="justify-content-end"
      class="auth-navbar fixed-top"
    >
      <ul class="navbar-nav">
        <router-link class="nav-item nav-item-button" tag="li" to="/login">
          <a class="nav-link">
            <i class="tim-icons icon-single-02"></i> Acessar plataforma
          </a>
        </router-link>
      </ul>
    </base-nav> -->
    <div class="wrapper wrapper-full-page">
      <div class="full-page" :class="pageClass">
        <div class="content">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <router-view></router-view>
          </zoom-center-transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BaseNav } from "src/components";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    BaseNav,
    ZoomCenterTransition,
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  data() {
    return {
      pageTransitionDuration: 200,
      pageClass: "login-page",
    };
  },
  created() {
    let docClasses = document.body.classList;
    docClasses.remove("white-content");
  },
  methods: {
    setPageClass() {
      this.pageClass = `${this.$route.name}-page`.toLowerCase();
    },
  },
  mounted() {
    this.setPageClass();
  },
  watch: {
    $route() {
      this.setPageClass();
    },
  },
};
</script>
<style scoped>
.nav-item-button {
  border: 1px;
  border-style: solid;
  color: white;
  padding: 10px;
}
a:hover {
  color: white;
}

.topright {
  position: absolute;
  top: 20px;
  right: 40px;
  z-index: 1000;
}
</style>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
</style>
